import * as React from "react";
import styled from "styled-components";
import {routeConfig} from "../../config/language/ja-JP/presentation/route_text";
import {AppNotificationMessage, AppNotificationType,} from "../../domain/model/app_notification_message";
import {createApiClient, IApiClient} from "../../infra/api/client";
import PageWrapper from "../common/atom/wrapper/page_wrapper";
import Breadcrumbs from "../common/molecular/breadcrumbs/breadcrumbs";
import AppNotificationWithTexts from "../common/organism/app_notification_with_texts";
import {TBreadcrumbItem} from "../type/common";
import {createClientConsultationAPI} from "../../infra/api/service/client_consultation";
import {RouteComponentProps} from "react-router";
import FormFieldWrapper from "../common/atom/wrapper/form_field_wrapper";
import {FrontDate} from "../../domain/model/frontDate";
import SubmitButtonWrapper from "../common/atom/wrapper/submit_btn_wrapper/submit_btn_wrapper";
import BtnCorporateLarge from "../common/atom/btn/btn_corporate_large";
import {api} from "../../infra/api/rpc/api";


const apiClient: IApiClient = createApiClient();
const consultationAPI = createClientConsultationAPI(apiClient);


interface IProps extends RouteComponentProps<{ action: string }> {
}

interface FormParams {
    label: string;
    value: string;
    isRequired: boolean;
    placeholder: string;
}


const ClientConsultationForm: React.FC<IProps> = (props) => {
    const [messages, setMessages] = React.useState<AppNotificationMessage[]>([]);
    const searchParams = new URLSearchParams(props.location.search);
    const typeParam = searchParams.get("type") || "";
    const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);

    const breadcrumbItems: TBreadcrumbItem[] = [
        routeConfig.clientRoot,
        {text: `案件相談`},
    ];

    const getTitle = (v: string): string => {
        switch (v) {
            case "1":
                return "アドバイザー";
            case "2":
                return "コンサルティング";
            case "3":
                return "メンタリング";
            case "4":
                return "リサーチ";
            case "5":
                return "研修";
            default:
                return "";
        }
    }

    const getForm = (v: string): FormParams[] => {
        switch (v) {
            case "1":
                return [
                    {
                        label: "経営課題の概要",
                        value: "",
                        isRequired: true,
                        placeholder: "ミドルマネジメント層の育成/採用に課題がある"
                    },
                    {label: "事業課題を抱えている貴社の部門名", value: "", isRequired: true, placeholder: "人事部"},
                    {
                        label: "お探しのエキスパートの要件",
                        value: "",
                        isRequired: true,
                        placeholder: "〇〇業界にてCHROのようなポジションで経営陣と人事課題の解決に取り組んでいた方"
                    },
                    {label: "契約開始想定", value: "", isRequired: true, placeholder: "2025年12月~"},
                    {label: "想定期間", value: "", isRequired: true, placeholder: "6ヶ月間"},
                    {label: "想定報酬（月額）", value: "", isRequired: false, placeholder: "30万円"},
                    {label: "その他（備考）", value: "", isRequired: false, placeholder: "その他"},
                ];
            case "2":
                return [
                    {
                        label: "対象の事業課題",
                        value: "",
                        isRequired: true,
                        placeholder: "ERPのリプレイス要件における事業立案"
                    },
                    {label: "事業課題を抱えている貴社の部門名", value: "", isRequired: true, placeholder: "ERP 営業部"},
                    {
                        label: "お探しのエキスパートの要件",
                        value: "",
                        isRequired: true,
                        placeholder: "元マイクロソフト Dynamics営業部出身者"
                    },
                    {label: "契約開始想定", value: "", isRequired: true, placeholder: "2025年12月~"},
                    {label: "想定期間", value: "", isRequired: true, placeholder: "6ヶ月間"},
                    {label: "想定報酬（月額）", value: "", isRequired: false, placeholder: "月 60万円"},
                    {label: "その他（備考）", value: "", isRequired: false, placeholder: "その他"},
                ];
            case "3":
                return [
                    {
                        label: "対象の課題",
                        value: "",
                        isRequired: true,
                        placeholder: "新規事業を担当している幹部に対して課題を棚卸しするための壁打ち相手になって欲しい"
                    },
                    {
                        label: "対象者の役職（役割）/部門",
                        value: "",
                        isRequired: true,
                        placeholder: "事業部長/金融サービス開発部門"
                    },
                    {
                        label: "お探しのエキスパートの要件",
                        value: "",
                        isRequired: true,
                        placeholder: "金融事業立ち上げの経験者、元〇〇社出身など"
                    },
                    {label: "想定面談時期", value: "", isRequired: true, placeholder: "2025年12月~"},
                    {label: "その他（備考）", value: "", isRequired: false, placeholder: "その他"},
                ];
            case "4":
                return [
                    {
                        label: "対象のリサーチ要件",
                        value: "",
                        isRequired: true,
                        placeholder: "Microsoftの競合調査 CRM領域"
                    },
                    {
                        label: "リサーチを行う予定の貴社の部門名",
                        value: "",
                        isRequired: true,
                        placeholder: "CRM 営業部"
                    },
                    {
                        label: "お探しのエキスパートの要件",
                        value: "",
                        isRequired: true,
                        placeholder: "元マイクロソフト Dynamics営業部出身者"
                    },
                    {label: "契約開始想定", value: "", isRequired: true, placeholder: "2025年12月~"},
                    {label: "想定期間", value: "", isRequired: true, placeholder: "6ヶ月間"},
                    {label: "その他（備考）", value: "", isRequired: false, placeholder: "その他"},
                ];
            case "5":
                return [
                    {
                        label: "想定の研修概要",
                        value: "",
                        isRequired: true,
                        placeholder: "AIツールに関する利用促進を行う上で社内理解を深める為の研修を行って欲しい"
                    },
                    {
                        label: "対象となる部門または役職（階級）",
                        value: "",
                        isRequired: true,
                        placeholder: "部長職"
                    },
                    {
                        label: "研修を通じて得たいゴール",
                        value: "",
                        isRequired: true,
                        placeholder: "AIツールを積極的に活用するようになり業務の生産性を向上させたい"
                    },
                    {label: "想定研修時期", value: "", isRequired: true, placeholder: "2025年12月~"},
                    {label: "想定予算", value: "", isRequired: true, placeholder: "200万円"},
                    {label: "その他（備考）", value: "", isRequired: false, placeholder: "その他"},
                ];
            default:
                return [];
        }
    }

    const [params, setParams] = React.useState<FormParams[]>(getForm(typeParam));

    const validation = (): boolean => {
        for (const item of params) {
            if (item.isRequired && !item.value) {
                setMessages([
                    AppNotificationMessage.from(
                        "",
                        AppNotificationType.ERROR,
                        `${item.label}は必須です`,
                        FrontDate.fromEmpty()
                    ),
                ]);
                return false;
            }
        }
        return true;
    }

    const handleInputChange = (index: number, value: string) => {
        const newParams = [...params];
        newParams[index].value = value;
        setParams(newParams);
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (isSubmitting) {
            return;
        }
        if (!validation()) {
            return;
        }

        setIsSubmitting(true);

        try {
            consultationAPI.send(
                `${getTitle(typeParam)}の送信がありました！`,
                params.map((v) => {
                    const req = new api.SendConsultationRequest.Item()
                    req.key = v.label
                    req.value = v.value
                    return req
                })
            ).then(() => {
                setTimeout(() => {
                    props.history.push("/client/consultation/complete");
                }, 500);
            });
        } catch (e) {
            setMessages([
                AppNotificationMessage.from(
                    "",
                    AppNotificationType.ERROR,
                    "エラーが発生しました",
                    FrontDate.fromEmpty()
                ),
            ]);
            setIsSubmitting(false);
        }
    };

    return (
        <React.Fragment>
            {messages.length > 0 && (
                <AppNotificationWithTexts
                    onClose={(id: string) =>
                        (event: any): void => {
                            setMessages([]);
                        }}
                    appNotificationMessages={messages}
                />
            )}

            <PageWrapper>
                <Breadcrumbs breadcrumbItems={breadcrumbItems}/>
                <Container>
                    <Title>案件相談 {getTitle(typeParam)}</Title>

                    <form
                        name="ClientConsultationForm"
                        onSubmit={handleSubmit}
                        style={{width: "100%", margin: "0 auto"}}
                    >
                        {params.map((param, index) => {
                            return (
                                <FormFieldWrapper key={index}>
                                    <Label>{param.label}</Label>
                                    {param.isRequired ? <Required/> : <></>}
                                    <div>
                                        <Input
                                            type="text"
                                            value={param.value}
                                            placeholder={param.placeholder}
                                            onChange={(e) => handleInputChange(index, e.target.value)}
                                            disabled={isSubmitting}
                                        />
                                    </div>
                                </FormFieldWrapper>
                            )
                        })}

                        <SubmitButtonWrapper>
                            <BtnCorporateLarge
                                name="ClientConsultationForm-submit"
                                type="submit"
                                widthSize="200px"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? "送信中..." : "送信"}
                            </BtnCorporateLarge>
                        </SubmitButtonWrapper>
                    </form>
                </Container>
            </PageWrapper>
        </React.Fragment>
    );
};

export default ClientConsultationForm;

const Container = styled.div`
    width: 100%;
`;

const Title = styled.div`
    font-size: 26px;
    font-weight: bold;
    margin-bottom: 32px;
    margin-top: 40px;
`;

const Label = styled.label`
    display: inline-block;
    margin-bottom: 10px;
`;

const Input = styled.input`
    width: 100%;
    height: 50px;
    padding: 0 10px;
`;

const Required = styled.span`
    margin-left: 5px;
    background-color: #ce4141;
    width: 5px;
    height: 5px;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
`;


// WEBPACK FOOTER //
// ./src/presentation/container/client_consultation_form.tsx